import {BLOCK_REGISTRY} from "@/widgets/editor/lib/registry";

const BlockRenderer = ({block}) => {
    const Component = BLOCK_REGISTRY[block.type];

    if (!Component) {
        console.warn(`Unknown block type: «${block.type}»`);
        return null;
    }

    return <Component {...block.data} />;
};

export default BlockRenderer;
